/* LockboxTCG homepage behaviour: header search + mobile nav, Instagram feed fan, newsletter validation. */

(function () {
  'use strict';

  /* ---------- Header: search + mobile nav ---------- */

  function setPanel(toggle, open) {
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
    if (open && panel.hasAttribute('data-lb-search-panel')) {
      var input = panel.querySelector('input[type="search"]');
      if (input) input.focus();
    }
  }

  function closeAllPanels(except) {
    document.querySelectorAll('[data-lb-panel-toggle][aria-expanded="true"]').forEach(function (toggle) {
      if (toggle !== except) setPanel(toggle, false);
    });
  }

  document.addEventListener('click', function (event) {
    // click outside an open country/language selector closes it
    document.querySelectorAll('details[data-lb-loc][open]').forEach(function (d) {
      if (!d.contains(event.target)) d.removeAttribute('open');
    });

    var toggle = event.target.closest('[data-lb-panel-toggle]');
    if (toggle) {
      event.preventDefault();
      var open = toggle.getAttribute('aria-expanded') !== 'true';
      closeAllPanels(toggle);
      setPanel(toggle, open);
      return;
    }
    // click outside an open panel closes it
    if (!event.target.closest('.lb-panel-drop')) closeAllPanels();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var openLoc = document.querySelector('details[data-lb-loc][open]');
    if (openLoc) {
      openLoc.removeAttribute('open');
      openLoc.querySelector('summary').focus();
      return;
    }
    var openToggle = document.querySelector('[data-lb-panel-toggle][aria-expanded="true"]');
    if (!openToggle) return;
    setPanel(openToggle, false);
    openToggle.focus();
  });

  // changing the language submits the localization form straight away
  document.addEventListener('change', function (event) {
    var select = event.target;
    if (select.matches && select.matches('.lb-loc__select') && select.form) select.form.submit();
  });

  /* ---------- Newsletter validation ---------- */

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-lb-news-form]');
    if (!form) return;
    var input = form.querySelector('input[type="email"]');
    var msg = form.querySelector('[data-lb-news-msg]');
    var value = input.value.trim();
    var error = '';
    if (!value) error = form.getAttribute('data-error-required');
    else if (!EMAIL_RE.test(value)) error = form.getAttribute('data-error-invalid');

    if (error) {
      event.preventDefault();
      msg.textContent = error;
      msg.classList.add('lb-news__msg--error');
      input.setAttribute('aria-invalid', 'true');
      input.focus();
    } else {
      msg.textContent = '';
      input.removeAttribute('aria-invalid');
    }
  });

  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('[data-lb-news-form] input[type="email"]')) return;
    if (input.getAttribute('aria-invalid') !== 'true') return;
    input.removeAttribute('aria-invalid');
    var msg = input.closest('form').querySelector('[data-lb-news-msg]');
    if (msg) msg.textContent = '';
  });

  /* ---------- Instagram feed fan ----------
     Each card's position is a function of its signed distance `d` from the active
     index (a = |d|); the CSS turns --d / data-a into transform, opacity, z-index. */

  class LbFeed extends HTMLElement {
    connectedCallback() {
      this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-lb-feed-card]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-lb-feed-dot]'));
      if (!this.cards.length) return;

      var start = parseInt(this.getAttribute('data-start'), 10);
      this.active = isNaN(start) ? Math.floor(this.cards.length / 2) : start;

      this.onClick = this.onClick.bind(this);
      this.onKey = this.onKey.bind(this);
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);

      this.touchX = null;
      this.addEventListener('touchstart', (e) => { this.touchX = e.changedTouches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', (e) => {
        if (this.touchX === null) return;
        var dx = e.changedTouches[0].clientX - this.touchX;
        this.touchX = null;
        if (Math.abs(dx) > 40) this.set(this.active + (dx < 0 ? 1 : -1));
      }, { passive: true });

      this.render();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKey);
    }

    set(index) {
      var n = this.cards.length;
      this.active = ((index % n) + n) % n; // wraps in both directions
      this.render();
    }

    onClick(event) {
      var control = event.target.closest('[data-lb-feed-prev], [data-lb-feed-next], [data-lb-feed-dot]');
      if (control) {
        event.preventDefault();
        if (control.hasAttribute('data-lb-feed-prev')) this.set(this.active - 1);
        else if (control.hasAttribute('data-lb-feed-next')) this.set(this.active + 1);
        else this.set(parseInt(control.getAttribute('data-lb-feed-dot'), 10));
        return;
      }
      // a side card makes itself active; the centre card is left alone (its link, if any, works normally)
      var card = event.target.closest('[data-lb-feed-card]');
      if (card && card.getAttribute('data-a') !== '0') {
        event.preventDefault();
        this.set(this.cards.indexOf(card));
      }
    }

    onKey(event) {
      if (event.key === 'ArrowLeft') this.set(this.active - 1);
      else if (event.key === 'ArrowRight') this.set(this.active + 1);
      else if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('[data-lb-feed-card]') && event.target.getAttribute('data-a') !== '0') {
        event.preventDefault();
        this.set(this.cards.indexOf(event.target));
      }
    }

    render() {
      this.cards.forEach((card, i) => {
        var d = i - this.active;
        var a = Math.min(Math.abs(d), 3);
        card.style.setProperty('--d', d);
        card.setAttribute('data-a', a);
        card.setAttribute('aria-hidden', a > 2 ? 'true' : 'false');
        card.setAttribute('tabindex', a === 0 || a > 2 ? '-1' : '0');
        var link = card.querySelector('.lb-feed__link');
        if (link) link.setAttribute('tabindex', a === 0 ? '0' : '-1');
      });
      this.dots.forEach((dot, i) => {
        dot.setAttribute('aria-current', i === this.active ? 'true' : 'false');
      });
    }
  }

  if (!customElements.get('lb-feed')) customElements.define('lb-feed', LbFeed);

  /* ---------- Photo carousel (About page) ----------
     A scroll-snap track; the arrows on each slide just scroll the neighbouring slide into view. */

  class LbCarousel extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', function (event) {
        var button = event.target.closest('[data-lb-car-prev], [data-lb-car-next]');
        if (!button) return;
        var slide = button.closest('.lb-carousel__slide');
        var target = button.hasAttribute('data-lb-car-prev') ? slide.previousElementSibling : slide.nextElementSibling;
        if (!target) return;
        var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', inline: 'center', block: 'nearest' });
      });

      // only the slide in view shows its arrows (neighbours peeking at the edges stay clean)
      var track = this.querySelector('.lb-carousel__track');
      var slides = Array.prototype.slice.call(this.querySelectorAll('.lb-carousel__slide'));
      if (!track || !slides.length) return;

      var update = function () {
        var box = track.getBoundingClientRect();
        var mid = box.left + box.width / 2;
        var best = slides[0];
        var bestDistance = Infinity;
        slides.forEach(function (slide) {
          var rect = slide.getBoundingClientRect();
          var distance = Math.abs(rect.left + rect.width / 2 - mid);
          if (distance < bestDistance) { best = slide; bestDistance = distance; }
        });
        slides.forEach(function (slide) { slide.toggleAttribute('data-active', slide === best); });
      };

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
      this.setAttribute('data-ready', '');
    }
  }

  if (!customElements.get('lb-carousel')) customElements.define('lb-carousel', LbCarousel);

  /* ---------- Hero product carousel (homepage) ----------
     Cross-fades between the curated slides every 5s. Pauses on hover/focus (WCAG 2.2.2: moving content
     needs a way to pause it) and while the tab is hidden. Respects prefers-reduced-motion by not
     auto-advancing at all - the first slide just stays put. */

  class LbHeroArt extends HTMLElement {
    connectedCallback() {
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-lb-hero-slide]'));
      if (this.slides.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var startActive = this.slides.findIndex(function (slide) { return slide.classList.contains('is-active'); });
      this.active = startActive < 0 ? 0 : startActive;
      this.paused = false;

      this.onEnter = this.onEnter.bind(this);
      this.onLeave = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnter);
      this.addEventListener('mouseleave', this.onLeave);
      this.addEventListener('focusin', this.onEnter);
      this.addEventListener('focusout', this.onLeave);

      this.timer = setInterval(() => {
        if (this.paused || document.hidden) return;
        this.set(this.active + 1);
      }, 5000);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
      this.removeEventListener('mouseenter', this.onEnter);
      this.removeEventListener('mouseleave', this.onLeave);
      this.removeEventListener('focusin', this.onEnter);
      this.removeEventListener('focusout', this.onLeave);
    }

    onEnter() { this.paused = true; }
    onLeave() { this.paused = false; }

    set(index) {
      var n = this.slides.length;
      var next = ((index % n) + n) % n;
      if (next === this.active) return;
      this.slides[this.active].classList.remove('is-active');
      this.slides[next].classList.add('is-active');
      this.active = next;
    }
  }

  if (!customElements.get('lb-hero-art')) customElements.define('lb-hero-art', LbHeroArt);

  /* ---------- Product gallery arrows ----------
     Adds previous / next arrows over the main product photo. They click the neighbouring
     thumbnail, so Dawn's media-gallery does the actual switching (and keeps thumbnails in sync). */

  var ARROW_PATHS = {
    prev: 'M20 4H7v2h13zM6 2h2v2H6zM4 4h2v2H4zM6 6h2v2H6z',
    next: 'M0 4h13v2H0zM12 2h2v2h-2zM14 4h2v2h-2zM12 6h2v2h-2z'
  };

  function galleryThumbnails(gallery) {
    var items = Array.prototype.slice.call(gallery.querySelectorAll('[id^="GalleryThumbnails"] [data-target]'));
    var visible = items.filter(function (item) { return item.getClientRects().length > 0; });
    return visible.length > 1 ? visible : items; // skip thumbnails hidden by "hide variant images"
  }

  function addGalleryArrows(root) {
    (root || document).querySelectorAll('media-gallery').forEach(function (gallery) {
      var viewer = gallery.querySelector('[id^="GalleryViewer"]');
      if (!viewer || viewer.querySelector('[data-lb-gal-prev]') || galleryThumbnails(gallery).length < 2) return;
      [['prev', 'Previous photo'], ['next', 'Next photo']].forEach(function (kind) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'lb-gallery__arrow lb-gallery__arrow--' + kind[0];
        button.setAttribute('aria-label', kind[1]);
        button.setAttribute('data-lb-gal-' + kind[0], '');
        button.innerHTML = '<svg width="16" height="8" viewBox="0 0 20 10" shape-rendering="crispEdges" aria-hidden="true" focusable="false"><path fill="currentColor" d="' + ARROW_PATHS[kind[0]] + '"/></svg>';
        viewer.appendChild(button);
      });
    });
  }

  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('[data-lb-gal-prev], [data-lb-gal-next]');
    if (!arrow) return;
    var gallery = arrow.closest('media-gallery');
    if (!gallery) return;
    var items = galleryThumbnails(gallery);
    if (items.length < 2) return;
    var current = 0;
    items.forEach(function (item, i) {
      var thumb = item.querySelector('button');
      if (thumb && thumb.getAttribute('aria-current') === 'true') current = i;
    });
    var step = arrow.hasAttribute('data-lb-gal-prev') ? -1 : 1;
    var target = items[(current + step + items.length) % items.length]; // wraps around at the ends
    var targetButton = target.querySelector('button');
    if (targetButton) targetButton.click();
  });

  addGalleryArrows();
  document.addEventListener('shopify:section:load', function (event) { addGalleryArrows(event.target); });
})();
